import PropTypes from 'prop-types';

export default function EventOnly({ event, children }) {
    if (!event) {
        return null;
    }

    return children;
}

EventOnly.defaultProps = {
    event: null
};

EventOnly.propTypes = {
    event: PropTypes.object,
    children: PropTypes.node
};
